module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"purchased_size":"{purchased_size} 사이즈 구매","usual_size":"(평소사이즈(상): {usual_size})"}}')
  delete Component.options._Ctor
}
